import React from 'react'

import Box from 'components_new/atoms/Box'
import CustomIcon from 'components_new/atoms/CustomIcon'
import IconButton from 'components_new/atoms/IconButton'
import Tooltip from 'components_new/atoms/Tooltip'
import { useTranslation } from 'language/translator'

export interface SidebarButtonProps {
  open: boolean
  toggleOpen: (value: boolean) => void
  variant: 'left' | 'right'
}

const SidebarButton = (props: SidebarButtonProps) => {
  const { open, toggleOpen, variant } = props
  const { t } = useTranslation()

  return (
    <Box>
      <Tooltip
        title={
          open
            ? t('global', 'close_side_panel')
            : t('global', 'open_side_panel')
        }
      >
        <IconButton onClick={() => toggleOpen(!open)}>
          <CustomIcon
            name={variant === 'left' ? 'LeftSidebar' : 'RightSidebar'}
          />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

SidebarButton.displayName = 'SidebarButton'
export default SidebarButton
